<section class="statistics">
   <h4 class="bold w-87">{{ 'general.statistics' | translate }}</h4>
   <main>
      <ng-container *ngIf="this.user?.institutionId === null">
         <div class="statistics-2 flex">
            <div
               (click)="changeValue(0)"
               [ngClass]="{ active: filter == 0 }"
               class="white-bg shadow flex"
            >
               {{ 'new_entries.all_documents' | translate }}
            </div>
            <div
               (click)="changeValue(1)"
               [ngClass]="{ active: filter == 1 }"
               class="white-bg shadow flex"
            >
               <h5>
                  {{ 'individual.statistics.cards' | translate }}
                  <span>0 - 5%</span>
               </h5>
               <img
                  style="
                     background: #44bd9e;
                     box-shadow: 0px 3px 15px #44bd9e82;
                  "
                  src="../../assets/images/document.png"
                  alt=""
               />
               <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  id="Capa_1"
                  width="40px"
                  viewBox="0 0 480 480"
                  style="enable-background: new 0 0 480 480"
                  xml:space="preserve"
                  class="files-icon"
               >
                  <g fill="#44bd9e">
                     <g fill="#44bd9e">
                        <path
                           d="M160,344h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,344,160,344z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#44bd9e">
                        <path
                           d="M384,344H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,344,384,344z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#44bd9e">
                        <path
                           d="M160,296h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,296,160,296z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#44bd9e">
                        <path
                           d="M384,296H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,296,384,296z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#44bd9e">
                        <path
                           d="M160,248h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,248,160,248z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#44bd9e">
                        <path
                           d="M384,248H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,248,384,248z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#44bd9e">
                        <path
                           d="M160,200h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,200,160,200z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#44bd9e">
                        <path
                           d="M384,200H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,200,384,200z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#44bd9e">
                        <path
                           d="M160,152h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,152,160,152z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#44bd9e">
                        <path
                           d="M384,152H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,152,384,152z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#44bd9e">
                        <path
                           d="M439.896,119.496c-0.04-0.701-0.177-1.393-0.408-2.056c-0.088-0.256-0.152-0.504-0.264-0.752    c-0.389-0.87-0.931-1.664-1.6-2.344l-112-112c-0.68-0.669-1.474-1.211-2.344-1.6c-0.248-0.112-0.496-0.176-0.744-0.264    c-0.669-0.23-1.366-0.37-2.072-0.416C320.328,0.088,320.176,0,320,0H96c-4.418,0-8,3.582-8,8v24H48c-4.418,0-8,3.582-8,8v432    c0,4.418,3.582,8,8,8h336c4.418,0,8-3.582,8-8v-40h40c4.418,0,8-3.582,8-8V120C440,119.824,439.912,119.672,439.896,119.496z     M328,27.312L412.688,112H328V27.312z M376,464H56V48h32v376c0,4.418,3.582,8,8,8h280V464z M424,416H104V16h208v104    c0,4.418,3.582,8,8,8h104V416z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#44bd9e">
                        <path
                           d="M192,72h-48c-4.418,0-8,3.582-8,8v48c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8V80C200,75.582,196.418,72,192,72z     M184,120h-32V88h32V120z"
                        />
                     </g>
                  </g>
                  <g fill="#44bd9e"></g>
                  <g fill="#44bd9e"></g>
                  <g fill="#44bd9e"></g>
                  <g fill="#44bd9e"></g>
                  <g fill="#44bd9e"></g>
                  <g fill="#44bd9e"></g>
                  <g fill="#44bd9e"></g>
                  <g fill="#44bd9e"></g>
                  <g fill="#44bd9e"></g>
                  <g fill="#44bd9e"></g>
                  <g fill="#44bd9e"></g>
                  <g fill="#44bd9e"></g>
                  <g fill="#44bd9e"></g>
                  <g fill="#44bd9e"></g>
                  <g fill="#44bd9e"></g>
               </svg>
            </div>
            <div
               (click)="changeValue(2)"
               [ngClass]="{ active: filter == 2 }"
               class="white-bg shadow flex"
            >
               <h5>
                  {{ 'individual.statistics.cards' | translate }}
                  <span>5 - 20%</span>
               </h5>
               <img
                  style="background: #f9a241; box-shadow: 0px 3px 15px #f9a241"
                  src="../../assets/images/document.png"
                  alt=""
               />
               <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  id="Capa_1"
                  width="40px"
                  viewBox="0 0 480 480"
                  style="enable-background: new 0 0 480 480"
                  xml:space="preserve"
                  class="files-icon"
               >
                  <g fill="#f9a241">
                     <g fill="#f9a241">
                        <path
                           d="M160,344h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,344,160,344z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f9a241">
                        <path
                           d="M384,344H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,344,384,344z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f9a241">
                        <path
                           d="M160,296h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,296,160,296z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f9a241">
                        <path
                           d="M384,296H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,296,384,296z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f9a241">
                        <path
                           d="M160,248h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,248,160,248z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f9a241">
                        <path
                           d="M384,248H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,248,384,248z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f9a241">
                        <path
                           d="M160,200h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,200,160,200z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f9a241">
                        <path
                           d="M384,200H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,200,384,200z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f9a241">
                        <path
                           d="M160,152h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,152,160,152z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f9a241">
                        <path
                           d="M384,152H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,152,384,152z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f9a241">
                        <path
                           d="M439.896,119.496c-0.04-0.701-0.177-1.393-0.408-2.056c-0.088-0.256-0.152-0.504-0.264-0.752    c-0.389-0.87-0.931-1.664-1.6-2.344l-112-112c-0.68-0.669-1.474-1.211-2.344-1.6c-0.248-0.112-0.496-0.176-0.744-0.264    c-0.669-0.23-1.366-0.37-2.072-0.416C320.328,0.088,320.176,0,320,0H96c-4.418,0-8,3.582-8,8v24H48c-4.418,0-8,3.582-8,8v432    c0,4.418,3.582,8,8,8h336c4.418,0,8-3.582,8-8v-40h40c4.418,0,8-3.582,8-8V120C440,119.824,439.912,119.672,439.896,119.496z     M328,27.312L412.688,112H328V27.312z M376,464H56V48h32v376c0,4.418,3.582,8,8,8h280V464z M424,416H104V16h208v104    c0,4.418,3.582,8,8,8h104V416z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f9a241">
                        <path
                           d="M192,72h-48c-4.418,0-8,3.582-8,8v48c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8V80C200,75.582,196.418,72,192,72z     M184,120h-32V88h32V120z"
                        />
                     </g>
                  </g>
                  <g fill="#f9a241"></g>
                  <g fill="#f9a241"></g>
                  <g fill="#f9a241"></g>
                  <g fill="#f9a241"></g>
                  <g fill="#f9a241"></g>
                  <g fill="#f9a241"></g>
                  <g fill="#f9a241"></g>
                  <g fill="#f9a241"></g>
                  <g fill="#f9a241"></g>
                  <g fill="#f9a241"></g>
                  <g fill="#f9a241"></g>
                  <g fill="#f9a241"></g>
                  <g fill="#f9a241"></g>
                  <g fill="#f9a241"></g>
                  <g fill="#f9a241"></g>
               </svg>
            </div>
            <div
               (click)="changeValue(3)"
               class="white-bg shadow flex"
               [ngClass]="{ active: filter == 3 }"
            >
               <h5>
                  {{ 'individual.statistics.cards' | translate }}
                  <span>20 - 100%</span>
               </h5>
               <img
                  style="
                     background: #f26f87;
                     box-shadow: 0px 3px 15px #f26f8782;
                  "
                  src="../../assets/images/document.png"
                  alt=""
               />
               <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  id="Capa_1"
                  width="40px"
                  viewBox="0 0 480 480"
                  style="enable-background: new 0 0 480 480"
                  xml:space="preserve"
                  class="files-icon"
               >
                  <g fill="#f26f87">
                     <g fill="#f26f87">
                        <path
                           d="M160,344h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,344,160,344z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f26f87">
                        <path
                           d="M384,344H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,344,384,344z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f26f87">
                        <path
                           d="M160,296h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,296,160,296z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f26f87">
                        <path
                           d="M384,296H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,296,384,296z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f26f87">
                        <path
                           d="M160,248h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,248,160,248z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f26f87">
                        <path
                           d="M384,248H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,248,384,248z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f26f87">
                        <path
                           d="M160,200h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,200,160,200z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f26f87">
                        <path
                           d="M384,200H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,200,384,200z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f26f87">
                        <path
                           d="M160,152h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,152,160,152z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f26f87">
                        <path
                           d="M384,152H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,152,384,152z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f26f87">
                        <path
                           d="M439.896,119.496c-0.04-0.701-0.177-1.393-0.408-2.056c-0.088-0.256-0.152-0.504-0.264-0.752    c-0.389-0.87-0.931-1.664-1.6-2.344l-112-112c-0.68-0.669-1.474-1.211-2.344-1.6c-0.248-0.112-0.496-0.176-0.744-0.264    c-0.669-0.23-1.366-0.37-2.072-0.416C320.328,0.088,320.176,0,320,0H96c-4.418,0-8,3.582-8,8v24H48c-4.418,0-8,3.582-8,8v432    c0,4.418,3.582,8,8,8h336c4.418,0,8-3.582,8-8v-40h40c4.418,0,8-3.582,8-8V120C440,119.824,439.912,119.672,439.896,119.496z     M328,27.312L412.688,112H328V27.312z M376,464H56V48h32v376c0,4.418,3.582,8,8,8h280V464z M424,416H104V16h208v104    c0,4.418,3.582,8,8,8h104V416z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f26f87">
                        <path
                           d="M192,72h-48c-4.418,0-8,3.582-8,8v48c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8V80C200,75.582,196.418,72,192,72z     M184,120h-32V88h32V120z"
                        />
                     </g>
                  </g>
                  <g fill="#f26f87"></g>
                  <g fill="#f26f87"></g>
                  <g fill="#f26f87"></g>
                  <g fill="#f26f87"></g>
                  <g fill="#f26f87"></g>
                  <g fill="#f26f87"></g>
                  <g fill="#f26f87"></g>
                  <g fill="#f26f87"></g>
                  <g fill="#f26f87"></g>
                  <g fill="#f26f87"></g>
                  <g fill="#f26f87"></g>
                  <g fill="#f26f87"></g>
                  <g fill="#f26f87"></g>
                  <g fill="#f26f87"></g>
                  <g fill="#f26f87"></g>
               </svg>
            </div>
         </div>
      </ng-container>

      <ng-container *ngIf="this.user?.institutionId !== null">
         <div class="statistics-2 flex">
            <div
               (click)="changeValue(0)"
               [ngClass]="{ active: filter == 0 && this.reSubmission !== true }"
               class="white-bg shadow flex"
            >
               {{ 'general.thesis' | translate }}
            </div>
            <div
               (click)="changeValue(1)"
               [ngClass]="{ active: filter == 1 && this.reSubmission !== true }"
               class="white-bg shadow flex"
            >
               <h5>
                  Thesis with similarity
                  <span>0 - 5%</span>
               </h5>
               <img
                  style="
                     background: #44bd9e;
                     box-shadow: 0px 3px 15px #44bd9e82;
                  "
                  src="../../assets/images/document.png"
                  alt=""
               />
               <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  id="Capa_1"
                  width="40px"
                  viewBox="0 0 480 480"
                  style="enable-background: new 0 0 480 480"
                  xml:space="preserve"
                  class="files-icon"
               >
                  <g fill="#44bd9e">
                     <g fill="#44bd9e">
                        <path
                           d="M160,344h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,344,160,344z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#44bd9e">
                        <path
                           d="M384,344H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,344,384,344z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#44bd9e">
                        <path
                           d="M160,296h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,296,160,296z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#44bd9e">
                        <path
                           d="M384,296H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,296,384,296z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#44bd9e">
                        <path
                           d="M160,248h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,248,160,248z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#44bd9e">
                        <path
                           d="M384,248H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,248,384,248z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#44bd9e">
                        <path
                           d="M160,200h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,200,160,200z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#44bd9e">
                        <path
                           d="M384,200H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,200,384,200z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#44bd9e">
                        <path
                           d="M160,152h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,152,160,152z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#44bd9e">
                        <path
                           d="M384,152H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,152,384,152z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#44bd9e">
                        <path
                           d="M439.896,119.496c-0.04-0.701-0.177-1.393-0.408-2.056c-0.088-0.256-0.152-0.504-0.264-0.752    c-0.389-0.87-0.931-1.664-1.6-2.344l-112-112c-0.68-0.669-1.474-1.211-2.344-1.6c-0.248-0.112-0.496-0.176-0.744-0.264    c-0.669-0.23-1.366-0.37-2.072-0.416C320.328,0.088,320.176,0,320,0H96c-4.418,0-8,3.582-8,8v24H48c-4.418,0-8,3.582-8,8v432    c0,4.418,3.582,8,8,8h336c4.418,0,8-3.582,8-8v-40h40c4.418,0,8-3.582,8-8V120C440,119.824,439.912,119.672,439.896,119.496z     M328,27.312L412.688,112H328V27.312z M376,464H56V48h32v376c0,4.418,3.582,8,8,8h280V464z M424,416H104V16h208v104    c0,4.418,3.582,8,8,8h104V416z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#44bd9e">
                        <path
                           d="M192,72h-48c-4.418,0-8,3.582-8,8v48c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8V80C200,75.582,196.418,72,192,72z     M184,120h-32V88h32V120z"
                        />
                     </g>
                  </g>
                  <g fill="#44bd9e"></g>
                  <g fill="#44bd9e"></g>
                  <g fill="#44bd9e"></g>
                  <g fill="#44bd9e"></g>
                  <g fill="#44bd9e"></g>
                  <g fill="#44bd9e"></g>
                  <g fill="#44bd9e"></g>
                  <g fill="#44bd9e"></g>
                  <g fill="#44bd9e"></g>
                  <g fill="#44bd9e"></g>
                  <g fill="#44bd9e"></g>
                  <g fill="#44bd9e"></g>
                  <g fill="#44bd9e"></g>
                  <g fill="#44bd9e"></g>
                  <g fill="#44bd9e"></g>
               </svg>
            </div>
            <div
               (click)="changeValue(2)"
               [ngClass]="{ active: filter == 2 && this.reSubmission !== true }"
               class="white-bg shadow flex"
            >
               <h5>
                  Thesis with similarity
                  <span>5 - 20%</span>
               </h5>
               <img
                  style="background: #f9a241; box-shadow: 0px 3px 15px #f9a241"
                  src="../../assets/images/document.png"
                  alt=""
               />
               <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  id="Capa_1"
                  width="40px"
                  viewBox="0 0 480 480"
                  style="enable-background: new 0 0 480 480"
                  xml:space="preserve"
                  class="files-icon"
               >
                  <g fill="#f9a241">
                     <g fill="#f9a241">
                        <path
                           d="M160,344h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,344,160,344z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f9a241">
                        <path
                           d="M384,344H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,344,384,344z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f9a241">
                        <path
                           d="M160,296h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,296,160,296z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f9a241">
                        <path
                           d="M384,296H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,296,384,296z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f9a241">
                        <path
                           d="M160,248h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,248,160,248z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f9a241">
                        <path
                           d="M384,248H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,248,384,248z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f9a241">
                        <path
                           d="M160,200h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,200,160,200z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f9a241">
                        <path
                           d="M384,200H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,200,384,200z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f9a241">
                        <path
                           d="M160,152h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,152,160,152z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f9a241">
                        <path
                           d="M384,152H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,152,384,152z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f9a241">
                        <path
                           d="M439.896,119.496c-0.04-0.701-0.177-1.393-0.408-2.056c-0.088-0.256-0.152-0.504-0.264-0.752    c-0.389-0.87-0.931-1.664-1.6-2.344l-112-112c-0.68-0.669-1.474-1.211-2.344-1.6c-0.248-0.112-0.496-0.176-0.744-0.264    c-0.669-0.23-1.366-0.37-2.072-0.416C320.328,0.088,320.176,0,320,0H96c-4.418,0-8,3.582-8,8v24H48c-4.418,0-8,3.582-8,8v432    c0,4.418,3.582,8,8,8h336c4.418,0,8-3.582,8-8v-40h40c4.418,0,8-3.582,8-8V120C440,119.824,439.912,119.672,439.896,119.496z     M328,27.312L412.688,112H328V27.312z M376,464H56V48h32v376c0,4.418,3.582,8,8,8h280V464z M424,416H104V16h208v104    c0,4.418,3.582,8,8,8h104V416z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f9a241">
                        <path
                           d="M192,72h-48c-4.418,0-8,3.582-8,8v48c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8V80C200,75.582,196.418,72,192,72z     M184,120h-32V88h32V120z"
                        />
                     </g>
                  </g>
                  <g fill="#f9a241"></g>
                  <g fill="#f9a241"></g>
                  <g fill="#f9a241"></g>
                  <g fill="#f9a241"></g>
                  <g fill="#f9a241"></g>
                  <g fill="#f9a241"></g>
                  <g fill="#f9a241"></g>
                  <g fill="#f9a241"></g>
                  <g fill="#f9a241"></g>
                  <g fill="#f9a241"></g>
                  <g fill="#f9a241"></g>
                  <g fill="#f9a241"></g>
                  <g fill="#f9a241"></g>
                  <g fill="#f9a241"></g>
                  <g fill="#f9a241"></g>
               </svg>
            </div>
            <div
               (click)="changeValue(3)"
               class="white-bg shadow flex"
               [ngClass]="{ active: filter == 3 && this.reSubmission !== true }"
            >
               <h5>
                  Thesis with similarity
                  <span>20 - 100%</span>
               </h5>
               <img
                  style="
                     background: #f26f87;
                     box-shadow: 0px 3px 15px #f26f8782;
                  "
                  src="../../assets/images/document.png"
                  alt=""
               />
               <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  id="Capa_1"
                  width="40px"
                  viewBox="0 0 480 480"
                  style="enable-background: new 0 0 480 480"
                  xml:space="preserve"
                  class="files-icon"
               >
                  <g fill="#f26f87">
                     <g fill="#f26f87">
                        <path
                           d="M160,344h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,344,160,344z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f26f87">
                        <path
                           d="M384,344H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,344,384,344z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f26f87">
                        <path
                           d="M160,296h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,296,160,296z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f26f87">
                        <path
                           d="M384,296H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,296,384,296z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f26f87">
                        <path
                           d="M160,248h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,248,160,248z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f26f87">
                        <path
                           d="M384,248H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,248,384,248z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f26f87">
                        <path
                           d="M160,200h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,200,160,200z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f26f87">
                        <path
                           d="M384,200H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,200,384,200z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f26f87">
                        <path
                           d="M160,152h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,152,160,152z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f26f87">
                        <path
                           d="M384,152H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,152,384,152z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f26f87">
                        <path
                           d="M439.896,119.496c-0.04-0.701-0.177-1.393-0.408-2.056c-0.088-0.256-0.152-0.504-0.264-0.752    c-0.389-0.87-0.931-1.664-1.6-2.344l-112-112c-0.68-0.669-1.474-1.211-2.344-1.6c-0.248-0.112-0.496-0.176-0.744-0.264    c-0.669-0.23-1.366-0.37-2.072-0.416C320.328,0.088,320.176,0,320,0H96c-4.418,0-8,3.582-8,8v24H48c-4.418,0-8,3.582-8,8v432    c0,4.418,3.582,8,8,8h336c4.418,0,8-3.582,8-8v-40h40c4.418,0,8-3.582,8-8V120C440,119.824,439.912,119.672,439.896,119.496z     M328,27.312L412.688,112H328V27.312z M376,464H56V48h32v376c0,4.418,3.582,8,8,8h280V464z M424,416H104V16h208v104    c0,4.418,3.582,8,8,8h104V416z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f26f87">
                        <path
                           d="M192,72h-48c-4.418,0-8,3.582-8,8v48c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8V80C200,75.582,196.418,72,192,72z     M184,120h-32V88h32V120z"
                        />
                     </g>
                  </g>
                  <g fill="#f26f87"></g>
                  <g fill="#f26f87"></g>
                  <g fill="#f26f87"></g>
                  <g fill="#f26f87"></g>
                  <g fill="#f26f87"></g>
                  <g fill="#f26f87"></g>
                  <g fill="#f26f87"></g>
                  <g fill="#f26f87"></g>
                  <g fill="#f26f87"></g>
                  <g fill="#f26f87"></g>
                  <g fill="#f26f87"></g>
                  <g fill="#f26f87"></g>
                  <g fill="#f26f87"></g>
                  <g fill="#f26f87"></g>
                  <g fill="#f26f87"></g>
               </svg>
            </div>
         </div>
         <div class="statistics-2 flex">
            <div
               (click)="changeValue(0, 1)"
               [ngClass]="{ active: filter == 0 && this.reSubmission == true }"
               class="white-bg shadow flex"
            >
               {{ 'app.upload.drafts' | translate }}
            </div>
            <div
               (click)="changeValue(1, 1)"
               [ngClass]="{ active: filter == 1 && this.reSubmission == true }"
               class="white-bg shadow flex"
            >
               <h5>
                  Drafts with similarity
                  <span>0 - 5%</span>
               </h5>
               <img
                  style="
                     background: #44bd9e;
                     box-shadow: 0px 3px 15px #44bd9e82;
                  "
                  src="../../assets/images/document.png"
                  alt=""
               />
               <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  id="Capa_1"
                  width="40px"
                  viewBox="0 0 480 480"
                  style="enable-background: new 0 0 480 480"
                  xml:space="preserve"
                  class="files-icon"
               >
                  <g fill="#44bd9e">
                     <g fill="#44bd9e">
                        <path
                           d="M160,344h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,344,160,344z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#44bd9e">
                        <path
                           d="M384,344H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,344,384,344z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#44bd9e">
                        <path
                           d="M160,296h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,296,160,296z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#44bd9e">
                        <path
                           d="M384,296H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,296,384,296z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#44bd9e">
                        <path
                           d="M160,248h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,248,160,248z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#44bd9e">
                        <path
                           d="M384,248H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,248,384,248z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#44bd9e">
                        <path
                           d="M160,200h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,200,160,200z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#44bd9e">
                        <path
                           d="M384,200H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,200,384,200z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#44bd9e">
                        <path
                           d="M160,152h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,152,160,152z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#44bd9e">
                        <path
                           d="M384,152H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,152,384,152z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#44bd9e">
                        <path
                           d="M439.896,119.496c-0.04-0.701-0.177-1.393-0.408-2.056c-0.088-0.256-0.152-0.504-0.264-0.752    c-0.389-0.87-0.931-1.664-1.6-2.344l-112-112c-0.68-0.669-1.474-1.211-2.344-1.6c-0.248-0.112-0.496-0.176-0.744-0.264    c-0.669-0.23-1.366-0.37-2.072-0.416C320.328,0.088,320.176,0,320,0H96c-4.418,0-8,3.582-8,8v24H48c-4.418,0-8,3.582-8,8v432    c0,4.418,3.582,8,8,8h336c4.418,0,8-3.582,8-8v-40h40c4.418,0,8-3.582,8-8V120C440,119.824,439.912,119.672,439.896,119.496z     M328,27.312L412.688,112H328V27.312z M376,464H56V48h32v376c0,4.418,3.582,8,8,8h280V464z M424,416H104V16h208v104    c0,4.418,3.582,8,8,8h104V416z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#44bd9e">
                        <path
                           d="M192,72h-48c-4.418,0-8,3.582-8,8v48c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8V80C200,75.582,196.418,72,192,72z     M184,120h-32V88h32V120z"
                        />
                     </g>
                  </g>
                  <g fill="#44bd9e"></g>
                  <g fill="#44bd9e"></g>
                  <g fill="#44bd9e"></g>
                  <g fill="#44bd9e"></g>
                  <g fill="#44bd9e"></g>
                  <g fill="#44bd9e"></g>
                  <g fill="#44bd9e"></g>
                  <g fill="#44bd9e"></g>
                  <g fill="#44bd9e"></g>
                  <g fill="#44bd9e"></g>
                  <g fill="#44bd9e"></g>
                  <g fill="#44bd9e"></g>
                  <g fill="#44bd9e"></g>
                  <g fill="#44bd9e"></g>
                  <g fill="#44bd9e"></g>
               </svg>
            </div>
            <div
               (click)="changeValue(2, 1)"
               [ngClass]="{ active: filter == 2 && this.reSubmission == true }"
               class="white-bg shadow flex"
            >
               <h5>
                  Drafts with similarity
                  <span>5 - 20%</span>
               </h5>
               <img
                  style="background: #f9a241; box-shadow: 0px 3px 15px #f9a241"
                  src="../../assets/images/document.png"
                  alt=""
               />
               <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  id="Capa_1"
                  width="40px"
                  viewBox="0 0 480 480"
                  style="enable-background: new 0 0 480 480"
                  xml:space="preserve"
                  class="files-icon"
               >
                  <g fill="#f9a241">
                     <g fill="#f9a241">
                        <path
                           d="M160,344h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,344,160,344z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f9a241">
                        <path
                           d="M384,344H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,344,384,344z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f9a241">
                        <path
                           d="M160,296h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,296,160,296z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f9a241">
                        <path
                           d="M384,296H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,296,384,296z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f9a241">
                        <path
                           d="M160,248h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,248,160,248z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f9a241">
                        <path
                           d="M384,248H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,248,384,248z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f9a241">
                        <path
                           d="M160,200h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,200,160,200z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f9a241">
                        <path
                           d="M384,200H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,200,384,200z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f9a241">
                        <path
                           d="M160,152h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,152,160,152z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f9a241">
                        <path
                           d="M384,152H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,152,384,152z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f9a241">
                        <path
                           d="M439.896,119.496c-0.04-0.701-0.177-1.393-0.408-2.056c-0.088-0.256-0.152-0.504-0.264-0.752    c-0.389-0.87-0.931-1.664-1.6-2.344l-112-112c-0.68-0.669-1.474-1.211-2.344-1.6c-0.248-0.112-0.496-0.176-0.744-0.264    c-0.669-0.23-1.366-0.37-2.072-0.416C320.328,0.088,320.176,0,320,0H96c-4.418,0-8,3.582-8,8v24H48c-4.418,0-8,3.582-8,8v432    c0,4.418,3.582,8,8,8h336c4.418,0,8-3.582,8-8v-40h40c4.418,0,8-3.582,8-8V120C440,119.824,439.912,119.672,439.896,119.496z     M328,27.312L412.688,112H328V27.312z M376,464H56V48h32v376c0,4.418,3.582,8,8,8h280V464z M424,416H104V16h208v104    c0,4.418,3.582,8,8,8h104V416z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f9a241">
                        <path
                           d="M192,72h-48c-4.418,0-8,3.582-8,8v48c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8V80C200,75.582,196.418,72,192,72z     M184,120h-32V88h32V120z"
                        />
                     </g>
                  </g>
                  <g fill="#f9a241"></g>
                  <g fill="#f9a241"></g>
                  <g fill="#f9a241"></g>
                  <g fill="#f9a241"></g>
                  <g fill="#f9a241"></g>
                  <g fill="#f9a241"></g>
                  <g fill="#f9a241"></g>
                  <g fill="#f9a241"></g>
                  <g fill="#f9a241"></g>
                  <g fill="#f9a241"></g>
                  <g fill="#f9a241"></g>
                  <g fill="#f9a241"></g>
                  <g fill="#f9a241"></g>
                  <g fill="#f9a241"></g>
                  <g fill="#f9a241"></g>
               </svg>
            </div>
            <div
               (click)="changeValue(3, 1)"
               class="white-bg shadow flex"
               [ngClass]="{ active: filter == 3 && this.reSubmission == true }"
            >
               <h5>
                  Drafts with similarity
                  <span>20 - 100%</span>
               </h5>
               <img
                  style="
                     background: #f26f87;
                     box-shadow: 0px 3px 15px #f26f8782;
                  "
                  src="../../assets/images/document.png"
                  alt=""
               />
               <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  id="Capa_1"
                  width="40px"
                  viewBox="0 0 480 480"
                  style="enable-background: new 0 0 480 480"
                  xml:space="preserve"
                  class="files-icon"
               >
                  <g fill="#f26f87">
                     <g fill="#f26f87">
                        <path
                           d="M160,344h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,344,160,344z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f26f87">
                        <path
                           d="M384,344H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,344,384,344z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f26f87">
                        <path
                           d="M160,296h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,296,160,296z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f26f87">
                        <path
                           d="M384,296H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,296,384,296z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f26f87">
                        <path
                           d="M160,248h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,248,160,248z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f26f87">
                        <path
                           d="M384,248H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,248,384,248z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f26f87">
                        <path
                           d="M160,200h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,200,160,200z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f26f87">
                        <path
                           d="M384,200H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,200,384,200z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f26f87">
                        <path
                           d="M160,152h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,152,160,152z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f26f87">
                        <path
                           d="M384,152H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,152,384,152z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f26f87">
                        <path
                           d="M439.896,119.496c-0.04-0.701-0.177-1.393-0.408-2.056c-0.088-0.256-0.152-0.504-0.264-0.752    c-0.389-0.87-0.931-1.664-1.6-2.344l-112-112c-0.68-0.669-1.474-1.211-2.344-1.6c-0.248-0.112-0.496-0.176-0.744-0.264    c-0.669-0.23-1.366-0.37-2.072-0.416C320.328,0.088,320.176,0,320,0H96c-4.418,0-8,3.582-8,8v24H48c-4.418,0-8,3.582-8,8v432    c0,4.418,3.582,8,8,8h336c4.418,0,8-3.582,8-8v-40h40c4.418,0,8-3.582,8-8V120C440,119.824,439.912,119.672,439.896,119.496z     M328,27.312L412.688,112H328V27.312z M376,464H56V48h32v376c0,4.418,3.582,8,8,8h280V464z M424,416H104V16h208v104    c0,4.418,3.582,8,8,8h104V416z"
                        />
                     </g>
                  </g>
                  <g>
                     <g fill="#f26f87">
                        <path
                           d="M192,72h-48c-4.418,0-8,3.582-8,8v48c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8V80C200,75.582,196.418,72,192,72z     M184,120h-32V88h32V120z"
                        />
                     </g>
                  </g>
                  <g fill="#f26f87"></g>
                  <g fill="#f26f87"></g>
                  <g fill="#f26f87"></g>
                  <g fill="#f26f87"></g>
                  <g fill="#f26f87"></g>
                  <g fill="#f26f87"></g>
                  <g fill="#f26f87"></g>
                  <g fill="#f26f87"></g>
                  <g fill="#f26f87"></g>
                  <g fill="#f26f87"></g>
                  <g fill="#f26f87"></g>
                  <g fill="#f26f87"></g>
                  <g fill="#f26f87"></g>
                  <g fill="#f26f87"></g>
                  <g fill="#f26f87"></g>
               </svg>
            </div>
         </div>
      </ng-container>

      <div
         class="white-bg shadow"
         *ngIf="submissionsDetails.totalUserSubmissionsAll !== 0"
      >
         <div class="flex your-documents">
            <h4 class="bold">
               {{ 'individual.your_documents' | translate }}:
               {{ submissionsDetails?.submissionsNumber }}
            </h4>
            <div class="input">
               <i class="fas fa-search"></i>
               <input
                  [(ngModel)]="title"
                  (ngModelChange)="titleFilter()"
                  class="search"
                  type="text"
                  placeholder="  {{ 'general.search' | translate }}"
               />
            </div>
         </div>
         <div
            *ngIf="
               (submissionsDetails.submissionsNumber == 0 &&
                  title == undefined &&
                  isFilterActive == false) ||
               (submissionsDetails.submissionsNumber == 0 &&
                  title == undefined &&
                  isFilterActive == true) ||
               (submissionsDetails.submissionsNumber == 0 &&
                  title !== undefined &&
                  isFilterActive == true) ||
               (submissionsDetails.submissionsNumber == 0 &&
                  title !== undefined &&
                  isFilterActive == false)
            "
            class="white-bg zero-state"
         >
            <!-- <img src="../../assets/images/icona-image.png" alt="" /> -->
            <h5 class="bold">{{ 'app.you_dont_have_any_documents_in_this_range' | translate }}</h5>
         </div>
         <div
            *ngIf="
               (submissionsDetails.submissionsNumber !== 0 &&
                  title == undefined &&
                  isFilterActive == false) ||
               (submissionsDetails.submissionsNumber !== 0 &&
                  title == undefined &&
                  isFilterActive == true) ||
               (submissionsDetails.submissionsNumber !== 0 &&
                  title !== undefined &&
                  isFilterActive == true) ||
               (submissionsDetails.submissionsNumber !== 0 &&
                  title !== undefined &&
                  isFilterActive == false)
            "
            class="scroll"
         >
            <i
               class="
                  animate__shakeX animate__animated
                  fas
                  fa-long-arrow-alt-right
               "
            ></i>
            <table>
               <tr>
                  <th>
                     <h5 class="bold left">
                        {{ 'general.table.name' | translate }}
                     </h5>
                  </th>
                  <th>
                     <h5 class="bold">{{ 'general.date' | translate }}</h5>
                  </th>
                  <th>
                     <h5 class="bold">
                        {{ 'general.table.number_of_words' | translate }}
                     </h5>
                  </th>
                  <th>
                     <h5 class="bold">
                        {{ 'general.language' | translate }}
                     </h5>
                  </th>
                  <th><h5 class="bold">{{ 'general.translated_language' | translate }}</h5></th>
                  <th>
                     <h5 class="bold">
                        {{ 'general.table.similarity_report' | translate }}
                     </h5>
                  </th>
                  <th *ngIf="this.user?.institutionId !== null">
                     <h5 class="bold">{{ 'general.status' | translate }}</h5>
                  </th>
                  <th *ngIf="this.user?.institutionId !== null">
                     <h5 class="bold">{{ 'general.table.draft' | translate }}</h5>
                  </th>
                  <th *ngIf="this.user?.institutionId === null">
                     <h5 class="bold">{{ 'app.delete' | translate }}</h5>
                  </th>
               </tr>
               <tr
                  *ngFor="
                     let submission of submissionsDetails?.submissions
                        | paginate
                           : {
                                itemsPerPage: pageSize,
                                currentPage: page,
                                totalItems:
                                   submissionsDetails?.submissionsNumber
                             }
                  "
               >
                  <ng-container *ngIf="submission.showSubmission == true">
                     <td>
                        <span
                           *ngIf="submission.draftId !== null"
                           style="font-weight: 700"
                           >{{ 'general.table.draft' | translate }}:
                        </span>
                        <h5 class="left">{{ submission.title }}</h5>
                     </td>
                     <td>
                        <span
                           *ngIf="submission.draftId !== null"
                           style="font-weight: 700"
                           >{{ 'general.table.draft' | translate }}:
                        </span>
                        <h5>
                           {{ submission.createdAt | localTime }}
                        </h5>
                     </td>
                     <td>
                        <h5>{{ submission.wordCount }}</h5>
                     </td>
                     <td>
                        <ng-container *ngIf="this.user?.institutionId === null">
                           <h5
                              *ngIf="submission.processed == 1"
                              [ngClass]="{
                                 'red-border':
                                    submission.originalPercentage.toFixed(2) >
                                    20,
                                 'green-border':
                                    submission.originalPercentage.toFixed(2) >=
                                       0 &&
                                    submission.originalPercentage.toFixed(2) <
                                       5,
                                 'orange-border':
                                    submission.originalPercentage.toFixed(2) >=
                                       5 &&
                                    submission.originalPercentage.toFixed(2) <=
                                       20
                              }"
                           >
                              <span *ngIf="submission.originalLanguage !== null"
                                 >{{ submission.originalLanguage | uppercase }}
                              </span>
                              <span *ngIf="submission.originalLanguage == null">
                                 --
                              </span>

                              {{ submission.originalPercentage.toFixed(2) }}%
                           </h5>
                        </ng-container>

                        <ng-container *ngIf="this.user?.institutionId !== null">
                           <ng-container *ngIf="submission.isPublic == 1">
                              <h5
                                 *ngIf="submission.processed == 1"
                                 [ngClass]="{
                                    'red-border':
                                       submission.originalPercentage.toFixed(
                                          2
                                       ) > 20,
                                    'green-border':
                                       submission.originalPercentage.toFixed(
                                          2
                                       ) >= 0 &&
                                       submission.originalPercentage.toFixed(
                                          2
                                       ) < 5,
                                    'orange-border':
                                       submission.originalPercentage.toFixed(
                                          2
                                       ) >= 5 &&
                                       submission.originalPercentage.toFixed(
                                          2
                                       ) <= 20
                                 }"
                              >
                                 <span
                                    *ngIf="submission.originalLanguage !== null"
                                    >{{
                                       submission.originalLanguage | uppercase
                                    }}
                                 </span>
                                 <span
                                    *ngIf="submission.originalLanguage == null"
                                 >
                                    --
                                 </span>

                                 {{ submission.originalPercentage.toFixed(2) }}%
                              </h5>
                           </ng-container>
                           <ng-container
                              *ngIf="
                                 submission.isPublic == 0 ||
                                 submission.isPublic === null
                              "
                           >
                              <h5
                                 *ngIf="submission.processed == 1"
                                 class="gray-border"
                              >
                                 <span> -- </span>
                                 --
                              </h5>
                           </ng-container>
                        </ng-container>
                        <h5
                           *ngIf="submission.processed == 2"
                           class="gray-border"
                        >
                           {{ 'app.suspended' | translate }}
                        </h5>
                        <h5
                           *ngIf="
                              submission.processed == 0 ||
                              submission.processed == -1
                           "
                           class="gray-border"
                        >
                           {{ 'report.processing' | translate }}
                        </h5>
                     </td>
                     <td>
                        <ng-container *ngIf="this.user?.institutionId === null">
                           <h5
                              *ngIf="submission.processed == 1"
                              [ngClass]="{
                                 'red-border':
                                    submission.translatedPercentage.toFixed(2) >
                                    20,

                                 'green-border':
                                    submission.translatedPercentage.toFixed(
                                       2
                                    ) >= 0 &&
                                    submission.translatedPercentage.toFixed(2) <
                                       5,

                                 'orange-border':
                                    submission.translatedPercentage.toFixed(
                                       2
                                    ) >= 5 &&
                                    submission.translatedPercentage.toFixed(
                                       2
                                    ) <= 20,

                                 'gray-border':
                                    submission.translatedLanguage == null
                              }"
                           >
                              <span
                                 *ngIf="submission.translatedLanguage !== null"
                                 >{{
                                    submission.translatedLanguage | uppercase
                                 }}
                              </span>
                              <span
                                 *ngIf="submission.translatedLanguage == null"
                              >
                                 --
                              </span>
                              <ng-container
                                 *ngIf="submission.translatedLanguage !== null"
                              >
                                 {{
                                    submission.translatedPercentage.toFixed(2)
                                 }}%
                              </ng-container>

                              <ng-container
                                 *ngIf="submission.translatedLanguage == null"
                              >
                                 ---
                              </ng-container>
                           </h5>
                        </ng-container>

                        <ng-container *ngIf="this.user?.institutionId !== null">
                           <ng-container *ngIf="submission.isPublic == 1">
                              <h5
                                 *ngIf="submission.processed == 1"
                                 [ngClass]="{
                                    'red-border':
                                       submission.translatedPercentage.toFixed(
                                          2
                                       ) > 20,

                                    'green-border':
                                       submission.translatedPercentage.toFixed(
                                          2
                                       ) >= 0 &&
                                       submission.translatedPercentage.toFixed(
                                          2
                                       ) < 5,

                                    'orange-border':
                                       submission.translatedPercentage.toFixed(
                                          2
                                       ) >= 5 &&
                                       submission.translatedPercentage.toFixed(
                                          2
                                       ) <= 20,

                                    'gray-border':
                                       submission.translatedLanguage == null
                                 }"
                              >
                                 <span
                                    *ngIf="
                                       submission.translatedLanguage !== null
                                    "
                                    >{{
                                       submission.translatedLanguage | uppercase
                                    }}
                                 </span>
                                 <span
                                    *ngIf="
                                       submission.translatedLanguage == null
                                    "
                                 >
                                    --
                                 </span>
                                 <ng-container
                                    *ngIf="
                                       submission.translatedLanguage !== null
                                    "
                                 >
                                    {{
                                       submission.translatedPercentage.toFixed(
                                          2
                                       )
                                    }}%
                                 </ng-container>

                                 <ng-container
                                    *ngIf="
                                       submission.translatedLanguage == null
                                    "
                                 >
                                    ---
                                 </ng-container>
                              </h5>
                           </ng-container>

                           <ng-container
                              *ngIf="
                                 submission.isPublic == 0 ||
                                 submission.isPublic == null
                              "
                           >
                              <h5
                                 *ngIf="submission.processed == 1"
                                 class="gray-border"
                              >
                                 <span> -- </span>
                                 <ng-container> --- </ng-container>
                              </h5>
                           </ng-container>
                        </ng-container>

                        <h5
                           *ngIf="
                              submission.processed == 0 ||
                              submission.processed == -1
                           "
                           class="gray-border"
                        >
                           {{ 'report.processing' | translate }}
                        </h5>
                        <h5
                           *ngIf="submission.processed == 2"
                           class="gray-border"
                        >
                           {{ 'app.suspended' | translate }}
                        </h5>
                     </td>
                     <td>
                        <ng-container *ngIf="this.user?.institutionId === null">
                           <a
                              *ngIf="submission.processed == 1"
                              (click)="goToLink(submission.id)"
                              class="blue-btn"
                              >{{ 'general.report' | translate }}</a
                           >
                        </ng-container>

                        <ng-container *ngIf="this.user?.institutionId !== null">
                           <a
                              *ngIf="
                                 submission.processed == 1 &&
                                 (submission.isPublic == 0 ||
                                    submission.isPublic == null)
                              "
                              (click)="showWarning('This document is private.')"
                              class="disable-btn"
                              >{{ 'general.report' | translate }}
                           </a>

                           <a
                              *ngIf="
                                 submission.processed == 1 &&
                                 submission.isPublic == 1
                              "
                              (click)="goToLink(submission.id)"
                              class="blue-btn"
                              >{{ 'general.report' | translate }}
                           </a>
                        </ng-container>

                        <a
                           *ngIf="
                              submission.processed == 0 ||
                              submission.processed == -1
                           "
                           (click)="
                              showWarning('Document is still processing.')
                           "
                           class="disable-btn"
                           >{{ 'general.report' | translate }}
                        </a>

                        <a
                           *ngIf="submission.processed == 2"
                           (click)="showAlertMessage()"
                           class="yellow-btn"
                        >
                           <svg
                              width="468"
                              height="431"
                              viewBox="0 0 468 431"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                           >
                              <path
                                 d="M406.65 122.69C405.98 111.19 392.44 102.39 364.73 94.95C365.5 93.01 365.96 90.95 366.08 88.86V41.51C363.38 2.26999 202.37 0.919983 183.43 0.919983C165.16 0.919983 3.48003 2.26999 0.780029 41.51V42.18V88.86C0.780029 101.71 17.69 111.86 42.05 119.3C42.05 120.65 41.38 121.33 41.38 122.68V123.35V170.03C15 176.8 1.47003 185.59 0.79003 197.09V197.76V244.44C0.79003 253.24 8.91003 260.68 21.75 267.44C21.2 268.72 20.97 270.11 21.08 271.5V272.17V318.85C21.08 341.17 71.81 355.38 127.99 362.14H130.02C140.84 363.49 151.67 364.17 162.49 364.84H163.84C177.37 365.51 191.58 366.19 203.75 366.19C215.92 366.19 230.13 365.52 243.66 364.84H245.01C255.83 364.17 266.66 363.49 277.48 362.14H279.51C335.66 355.37 386.42 341.84 386.42 318.85V271.5C385.75 263.38 378.98 256.62 364.77 250.54C365.54 248.6 366 246.54 366.12 244.45V200.48C390.47 193.04 406.71 182.87 406.71 170.04V122.67L406.65 122.69ZM393.12 123.36C392.45 128.1 382.3 134.18 363.35 139.6C339.67 147.04 301.79 153.81 254.43 155.84H193.55C146.18 153.81 108.31 147.04 84.63 139.6C66.36 134.19 55.54 128.1 54.86 123.36V122.69H56.21L64.33 124.72C78.85 127.79 93.53 130.05 108.3 131.49C119.12 132.84 130.62 133.52 142.12 134.19C150.24 134.86 159.03 134.86 167.15 135.54H193.53C242.92 134.87 288.24 128.77 320.03 119.98C321.38 119.31 322.73 119.31 324.09 118.63C324.76 118.63 326.12 117.96 326.79 117.96C329.19 117.48 331.48 116.56 333.56 115.26C334.23 115.26 334.23 115.26 334.91 114.59C336.75 114.03 338.56 113.35 340.32 112.56C340.83 112.49 341.31 112.25 341.67 111.89C343.7 111.22 345.05 109.86 347.08 109.19C347.75 108.52 348.43 108.52 349.11 107.84C349.78 107.16 350.46 107.17 351.81 106.49C352.48 106.49 352.48 105.82 353.16 105.82C384.32 113.22 392.44 120.66 393.12 123.36ZM184.08 14.45C295.7 14.45 351.85 32.06 353.2 42.19C352.53 46.93 341.7 53.01 323.43 58.43C299.75 65.87 261.87 72.64 214.51 74.67H153.63C106.26 72.64 68.39 65.87 44.72 58.43C26.45 53.02 15.63 46.93 14.95 42.19C15.63 32.04 72.44 14.45 184.08 14.45ZM47.41 182.89C56.88 192.36 76.5 199.8 100.18 205.21C100.85 205.21 101.53 205.21 101.53 205.88C103.56 206.55 104.91 206.55 106.94 207.23C132.12 212.47 157.69 215.64 183.38 216.7C192.85 217.37 201.65 217.37 211.79 218.05H238.17C246.97 218.05 255.78 217.38 264.55 216.7C290.71 215.38 316.72 211.99 342.35 206.55C335.89 209.96 329.09 212.68 322.05 214.67C297.02 222.79 256.43 229.55 205.02 230.91H152.28C104.91 228.88 67.04 222.11 43.36 214.67C24.42 209.26 14.27 202.51 13.59 198.43C15.62 195.05 22.39 188.96 47.42 182.88L47.41 182.89ZM372.8 272.19C372.13 276.93 361.98 283.01 343.03 288.43C319.35 295.87 281.47 302.64 234.11 304.67H173.25C125.88 302.64 88.01 295.87 64.34 288.43C46.73 283.02 35.93 276.93 34.57 272.19L40.66 274.22H41.33C43.04 274.99 44.87 275.44 46.74 275.57C47.41 275.57 48.09 276.24 48.77 276.24C50.12 276.24 50.8 276.91 52.15 276.91C81.7 283.85 111.81 288.15 142.12 289.76C152.94 290.43 163.08 290.43 173.91 291.11H194.21C204.36 291.11 213.83 290.44 223.3 289.76C234.8 289.09 246.3 287.73 257.12 287.06H257.79C269.95 285.71 281.47 283.68 291.61 281.65C293.64 280.98 295.67 280.98 298.38 280.3H299.73C316.9 277.37 333.54 271.9 349.1 264.07C349.77 263.4 350.45 263.4 351.13 262.72C351.8 262.04 352.48 262.05 353.16 261.37C353.84 260.69 354.51 260.7 355.19 260.02C368.73 266.11 372.79 270.85 372.79 272.2L372.8 272.19Z"
                                 fill="white"
                              />
                              <path
                                 d="M365.11 430.92C421.835 430.92 467.82 384.935 467.82 328.21C467.82 271.485 421.835 225.5 365.11 225.5C308.385 225.5 262.4 271.485 262.4 328.21C262.4 384.935 308.385 430.92 365.11 430.92Z"
                                 fill="#ECC332"
                              />
                              <path
                                 d="M365.1 430.92C308.46 430.92 262.39 384.85 262.39 328.21C262.39 271.57 308.47 225.5 365.1 225.5C421.74 225.5 467.81 271.57 467.81 328.21C467.81 384.85 421.74 430.92 365.1 430.92ZM365.1 259.04C326.96 259.04 295.93 290.07 295.93 328.21C295.93 366.35 326.96 397.38 365.1 397.38C403.24 397.38 434.27 366.35 434.27 328.21C434.27 290.07 403.25 259.04 365.1 259.04Z"
                                 fill="white"
                              />
                              <path
                                 d="M393.37 337.645H374.24V356.322H356.808V337.645H337.565V321.119H356.808V302.442H374.24V321.119H393.37V337.645Z"
                                 fill="white"
                              />
                           </svg>
                           {{ 'general.add_credits' | translate }}
                           <div class="fas fa-info-circle tooltip">
                              <div class="left">
                                 <p>
                                    You don't have enough credits. <br />Add
                                    credits to process the document.
                                 </p>
                              </div>
                           </div>
                        </a>
                     </td>
                     <td
                        *ngIf="
                           this.user?.institutionId !== null &&
                           submission.isPublic == 1
                        "
                        style="color: green"
                     >
                        {{ 'general.public' | translate }}
                     </td>
                     <td
                        style="color: red"
                        *ngIf="
                           this.user?.institutionId !== null &&
                           (submission.isPublic == 0 ||
                              submission.isPublic === null)
                        "
                     >
                        {{ 'general.private' | translate }}
                     </td>
                     <td *ngIf="this.user?.institutionId !== null">
                        <ng-container
                           *ngIf="
                              submission.processed == 0 ||
                              submission.processed == -1 ||
                              !submission.reSubmission
                           "
                        >
                           <a
                              class="blue-btn"
                              style="opacity: 0.5; cursor: not-allowed"
                           >
                              {{ 'general.table.draft' | translate }}
                           </a>
                        </ng-container>
                        <ng-container
                           *ngIf="
                              submission.processed == 1 &&
                              submission.reSubmission
                           "
                        >
                           <a class="blue-btn">{{ 'general.table.draft' | translate }}</a>
                        </ng-container>
                     </td>
                     <td *ngIf="this.user?.institutionId === null">
                        <a
                           *ngIf="
                              submission.processed === 1 ||
                              submission.processed === 2
                           "
                           (click)="
                              deleteSubmissionAlert(
                                 submission.id,
                                 submission.showSubmission
                              )
                           "
                           class="delete-btn"
                           ><i class="fas fa-trash-alt"></i> {{ 'app.delete' | translate }}</a
                        >
                        <a
                           *ngIf="
                              submission.processed === -1 ||
                              submission.processed === 0
                           "
                           (click)="
                              showWarning(
                                 'You can\'t delete submission that is being processed'
                              )
                           "
                           class="disable-btn"
                           ><i class="fas fa-trash-alt"></i> {{ 'app.delete' | translate }}</a
                        >
                     </td>
                  </ng-container>
               </tr>
            </table>
         </div>
         <pagination-controls
            class="num"
            (pageChange)="changePage($event)"
            autoHide="true"
            responsive="true"
            previousLabel=""
            nextLabel=""
         ></pagination-controls>
      </div>

      <div
         *ngIf="submissionsDetails.totalUserSubmissionsAll == 0"
         class="white-bg zero-state"
      >
         <!-- <img src="../../assets/images/icona-image.png" alt="" /> -->
         <h5 class="bold">
            {{ 'individual.dashboard.zero_state.first_paragraph' | translate }}
         </h5>
         <p>{{ 'individual.dashboard.zero_state.second_paragraph' | translate }}</p>
         <button routerLink="/individual/add-credits" class="blue-btn">
            {{ 'general.add_credits' | translate }}
         </button>
      </div>

      <div class="white-bg border padding-40">
         <div
            *ngIf="submissionsDetails.totalUserSubmissionsAll == 0"
            class="zero-state-statistics"
         >
            <div class="flex">
               <h4>{{ 'individual.statistics.documents_and_number_of_words' | translate }}</h4>
               <img src="../../assets/images/icons.png" alt="" />
            </div>
            <img
               class="zero-state-img"
               src="../../assets/images/statistics.png"
               alt=""
            />
         </div>
         <div
            *ngIf="submissionsDetails.totalUserSubmissionsAll !== 0"
            id="chart"
         >
            <apx-chart
               [series]="chartOptions.series"
               [chart]="chartOptions.chart"
               [yaxis]="chartOptions.yaxis"
               [xaxis]="chartOptions.xaxis"
               [labels]="chartOptions.labels"
               [stroke]="chartOptions.stroke"
               [title]="chartOptions.title"
               [dataLabels]="chartOptions.dataLabels"
               [fill]="chartOptions.fill"
               [tooltip]="chartOptions.tooltip"
            ></apx-chart>
         </div>

         <select
            *ngIf="submissionsDetails.totalUserSubmissionsAll !== 0"
            name="city"
            [(ngModel)]="year"
            (change)="onChange($event.target.value)"
         >
            <option *ngFor="let year of years" [value]="year.value">
               {{ year.name }}
            </option>
         </select>
      </div>

      <h4 class="bold">
         {{ 'individual.statistics.creditsDetails.your_credits' | translate }}
      </h4>

      <ng-container *ngIf="this.user?.institutionId !== null">
         <div class="flex your-credits">
            <div class="flex border white-bg">
               <h4 class="bold">{{ 'add_credits.purchased_credits' | translate }}</h4>
               <h6 style="color: #f9a241">
                  <span
                     style="
                        background: #f9a241;
                        border: 11px solid rgba(249, 162, 65, 0.53);
                     "
                  >
                  </span>
                  {{
                     this.submissionsDetails.userTotalCredits ||
                        0 + this.submissionsDetails.userUsedCredits ||
                        0
                  }}
                  {{ 'general.credits' | translate }}
               </h6>
            </div>
            <div class="flex border white-bg">
               <h4 class="bold">
                  {{
                     'individual.statistics.creditsDetails.used_credits'
                        | translate
                  }}
               </h4>
               <h6 style="color: #f26f87">
                  <span
                     style="
                        border: 11px solid rgba(242, 111, 135, 0.53);
                        background: #f26f87;
                     "
                  ></span>
                  {{ this.submissionsDetails.userUsedCredits || 0 }}
                  {{ 'general.credits' | translate }}
               </h6>
            </div>
            <div class="flex border white-bg">
               <h4 class="bold">
                  {{
                     'individual.statistics.creditsDetails.available_credits'
                        | translate
                  }}
               </h4>
               <h6 style="color: #38b98c">
                  <span
                     style="
                        background: #38b98c;
                        border: 11px solid rgba(56, 185, 140, 0.53);
                     "
                  ></span>
                  {{ this.submissionsDetails.userTotalCredits || 0 }}
                  {{ 'general.credits' | translate }}
               </h6>
            </div>
            <div class="flex border white-bg">
               <h4 class="bold add-more-credits">
                  {{
                     'individual.statistics.creditsDetails.add_more_credits'
                        | translate
                  }}
               </h4>
               <h6 style="color: #c796c4">
                  <span
                     style="
                        background: rgba(199, 150, 196, 1);
                        border: 11px solid rgba(199, 150, 196, 0.53);
                     "
                  ></span>
                  <a routerLink="/individual/add-credits">{{ 'general.checkout' | translate }}</a>
               </h6>
            </div>
         </div>

         <div class="flex your-credits">
            <div class="flex border white-bg">
               <h4 class="bold">{{ 'add_credits.purchased_thesis' | translate }}</h4>
               <h6 style="color: #f9a241">
                  <span
                     style="
                        background: #f9a241;
                        border: 11px solid rgba(249, 162, 65, 0.53);
                     "
                  >
                  </span>
                  {{
                     this.submissionsDetails.totalUserDocuments ||
                        0 + this.submissionsDetails.totalUserDocumentsUsed ||
                        0
                  }}
                  {{ 'general.thesis' | translate }}
               </h6>
            </div>
            <div class="flex border white-bg">
               <h4 class="bold">{{ 'app.upload.used_thesis' | translate }}</h4>
               <h6 style="color: #f26f87">
                  <span
                     style="
                        border: 11px solid rgba(242, 111, 135, 0.53);
                        background: #f26f87;
                     "
                  ></span>
                  {{ this.submissionsDetails.totalUserDocumentsUsed || 0 }}
                  {{ 'general.thesis' | translate }}
               </h6>
            </div>
            <div class="flex border white-bg">
               <h4 class="bold">{{ 'general.available_thesis' | translate }}</h4>
               <h6 style="color: #38b98c">
                  <span
                     style="
                        background: #38b98c;
                        border: 11px solid rgba(56, 185, 140, 0.53);
                     "
                  ></span>
                  {{ this.submissionsDetails.totalUserDocuments || 0 }}
                  {{ 'general.thesis' | translate }}
               </h6>
            </div>
            <div class="flex border white-bg">
               <h4 class="bold add-more-credits">{{ 'general.available_thesis' | translate }}</h4>
               <h6 style="color: #c796c4">
                  <span
                     style="
                        background: rgba(199, 150, 196, 1);
                        border: 11px solid rgba(199, 150, 196, 0.53);
                     "
                  ></span>
                  <a routerLink="/individual/add-credits">{{ 'general.checkout' | translate }}</a>
               </h6>
            </div>
         </div>

         <div class="flex your-credits">
            <div class="flex border white-bg">
               <h4 class="bold">{{ 'add_credits.purchased_drafts' | translate }}</h4>
               <h6 style="color: #f9a241">
                  <span
                     style="
                        background: #f9a241;
                        border: 11px solid rgba(249, 162, 65, 0.53);
                     "
                  >
                  </span>
                  {{
                     this.submissionsDetails.totalUserDrafts ||
                        0 + this.submissionsDetails.totalUserDraftsUsed ||
                        0
                  }}
                  {{ 'app.upload.drafts' | translate }}
               </h6>
            </div>

            <div class="flex border white-bg">
               <h4 class="bold">{{ 'app.upload.used_drafts' | translate }}</h4>
               <h6 style="color: #f26f87">
                  <span
                     style="
                        border: 11px solid rgba(242, 111, 135, 0.53);
                        background: #f26f87;
                     "
                  ></span>
                  {{ this.submissionsDetails.totalUserDraftsUsed || 0 }}
                  {{ 'app.upload.drafts' | translate }}
               </h6>
            </div>

            <div class="flex border white-bg">
               <h4 class="bold">{{ 'general.available_drafts' | translate }}</h4>
               <h6 style="color: #38b98c">
                  <span
                     style="
                        background: #38b98c;
                        border: 11px solid rgba(56, 185, 140, 0.53);
                     "
                  ></span>
                  {{ this.submissionsDetails.totalUserDrafts || 0 }}
                  {{ 'app.upload.drafts' | translate }}
               </h6>
            </div>

            <div class="flex border white-bg">
               <h4 class="bold add-more-credits">{{ 'general.available_drafts' | translate }}</h4>
               <h6 style="color: #c796c4">
                  <span
                     style="
                        background: rgba(199, 150, 196, 1);
                        border: 11px solid rgba(199, 150, 196, 0.53);
                     "
                  ></span>
                  <a routerLink="/individual/add-credits">{{ 'general.checkout' | translate }}</a>
               </h6>
            </div>
         </div>
      </ng-container>

      <ng-container *ngIf="this.user?.institutionId === null">
         <div class="flex your-credits">
            <div class="flex border white-bg">
               <h4 class="bold">{{ 'add_credits.total_bought_credits' | translate }}</h4>
               <h6 style="color: #f9a241">
                  <span
                     style="
                        background: #f9a241;
                        border: 11px solid rgba(249, 162, 65, 0.53);
                     "
                  >
                  </span>
                  {{ this.transactions?.totalUserBoughtCredits }}
                  {{ 'general.credits' | translate }}
               </h6>
            </div>
            <div class="flex border white-bg">
               <h4 class="bold">
                  {{
                     'individual.statistics.creditsDetails.used_credits'
                        | translate
                  }}
               </h4>
               <h6 style="color: #f26f87">
                  <span
                     style="
                        border: 11px solid rgba(242, 111, 135, 0.53);
                        background: #f26f87;
                     "
                  ></span>
                  {{ this.transactions?.totalUserUsedCredits }}
                  {{ 'general.credits' | translate }}
               </h6>
            </div>
            <div class="flex border white-bg">
               <h4 class="bold">
                  {{
                     'individual.statistics.creditsDetails.available_credits'
                        | translate
                  }}
               </h4>
               <h6 style="color: #38b98c">
                  <span
                     style="
                        background: #38b98c;
                        border: 11px solid rgba(56, 185, 140, 0.53);
                     "
                  ></span>
                  {{
                     transactions?.totalUserBoughtCredits -
                        transactions?.totalUserUsedCredits
                  }}
                  {{ 'general.credits' | translate }}
               </h6>
            </div>
            <div class="flex border white-bg">
               <h4 class="bold add-more-credits">
                  {{
                     'individual.statistics.creditsDetails.add_more_credits'
                        | translate
                  }}
               </h4>
               <h6 style="color: #c796c4">
                  <span
                     style="
                        background: rgba(199, 150, 196, 1);
                        border: 11px solid rgba(199, 150, 196, 0.53);
                     "
                  ></span>
                  <a routerLink="/individual/add-credits">{{
                     'individual.statistics.creditsDetails.buy_credits'
                        | translate
                  }}</a>
               </h6>
            </div>
         </div>
         <div class="flex column unset">
            <div class="credits-chart white-bg border padding-40">
               <h4 class="bold">{{ 'general.credits' | translate }}</h4>
               <div id="creditsChart">
                  <apx-chart
                     [series]="creditsChartOptions.series"
                     [chart]="creditsChartOptions.chart"
                     [xaxis]="creditsChartOptions.xaxis"
                     [stroke]="creditsChartOptions.stroke"
                     [tooltip]="creditsChartOptions.tooltip"
                     [dataLabels]="creditsChartOptions.dataLabels"
                  ></apx-chart>
               </div>
            </div>
            <div class="last-transaction white-bg border">
               <h4 class="bold">{{ 'add_credits.last_transaction' | translate }}</h4>
               <ng-container
                  *ngIf="transactionsPagination?.transactions.length > 0"
               >
                  <div class="scroll">
                     <div class="grid border">
                        <h5 class="bold">{{ 'general.number' | translate }}</h5>
                        <h5 class="bold">{{ 'general.date' | translate }}</h5>
                        <h5 class="bold">
                           {{ 'general.credits' | translate }}
                        </h5>
                        <h5 class="bold">{{ 'general.words' | translate }}</h5>
                        <h5 class="bold">{{ 'general.total' | translate }}</h5>
                     </div>
                     <ng-container
                        *ngFor="
                           let transaction of transactionsPagination?.transactions
                              | paginate
                                 : {
                                      id: 'transactionsPagination',
                                      itemsPerPage: pageSize,
                                      currentPage: pageTransaction,
                                      totalItems:
                                         transactionsPagination?.userTotalTransactions
                                   };
                           let i = index
                        "
                     >
                        <div class="grid">
                           <h5>{{ transaction.refNo }}</h5>
                           <h5>{{ transaction.createdAt.split('T')[0] }}</h5>
                           <h5>{{ transaction.words / 100 }}</h5>
                           <h5>{{ transaction.words }}</h5>
                           <h5>
                              {{
                                 transaction.price
                                    | currency: transaction.currency:true
                              }}
                           </h5>
                        </div>
                     </ng-container>
                     <pagination-controls
                        id="transactionsPagination"
                        class="num"
                        (pageChange)="changeTransactionPage($event)"
                        autoHide="true"
                        responsive="true"
                        previousLabel=""
                        nextLabel=""
                     ></pagination-controls>
                  </div>
                  <div class="center">
                     <button
                        class="shadow border blue-btn"
                        (click)="downloadExcel()"
                     >
                        <i class="fas fa-download"></i>{{ 'app.download_template' | translate }}
                     </button>
                  </div>
               </ng-container>
               <ng-container
                  *ngIf="transactionsPagination?.transactions.length === 0"
               >
                  <div
                     style="
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        height: 100%;
                     "
                  >
                     <span> You don't have any transaction </span>
                  </div>
               </ng-container>
            </div>
         </div>
      </ng-container>
   </main>
</section>
